import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { TextBox } from '@progress/kendo-react-inputs';
import {
  load,
  loadMessages,
} from '@progress/kendo-react-intl';
import styles from './_name-date-of-birth-login.module.scss';
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from 'cldr-core/supplemental/weekData.json';
import numbers from 'cldr-numbers-full/main/es/numbers.json';
import caGregorian from 'cldr-dates-full/main/es/ca-gregorian.json';
import dateFields from 'cldr-dates-full/main/es/dateFields.json';
import timeZoneNames from 'cldr-dates-full/main/es/timeZoneNames.json';
import esMessages from './es.json';
import { getMonthsForLanguage, getWordingForLanguage } from '../../../Helpers/LanguageDictionary';
import { isNotNil } from 'ramda';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { dateOfBirthYearOptions, getDaysForMonthName } from '../../../Helpers/DateHelpers';

load(
  likelySubtags,
  currencyData,
  weekData,
  numbers,
  caGregorian,
  dateFields,
  timeZoneNames
);
loadMessages(esMessages, 'es');

export interface NameDoBLoginProps {
  selectedLanguageId: string;
  canLogin: boolean;
  loggingIn: boolean;
  lastName?: string;
  year?: string;
  month?: string;
  day?: string;
  onLastNameChange: (value: string) => void;
  onYearChange: (value: string) => void;
  onMonthChange: (monthId: string) => void;
  onDayChange: (value: string) => void;
  onUseAlternateLogin: () => void;
  onLogin: () => void;
}

const NameDoBLogin = (props: NameDoBLoginProps) => {
  return (
    <div className={styles.nameDobContainer}>
      <div className={styles.inputCol}>
        <div>{getWordingForLanguage('lastName', props.selectedLanguageId)}</div>
        <TextBox
          value={props.lastName}
          onChange={(e) => props.onLastNameChange(e.value as string)}
          placeholder={`${getWordingForLanguage('lastName', props.selectedLanguageId)}...`}
          fillMode="outline"
          style={{ width: '100%' }}
        />
      </div>
      <DropDownList
        data={dateOfBirthYearOptions.sort((a: number, b: number) => b - a)}
        label={getWordingForLanguage('year', props.selectedLanguageId)}
        fillMode='outline'
        value={props.year?.toString() ?? ''}
        onChange={(e: DropDownListChangeEvent) => {
          props.onYearChange(e.target.value);
        }}
      />
      <DropDownList
        data={getMonthsForLanguage(props.selectedLanguageId)}
        label={getWordingForLanguage('month', props.selectedLanguageId)}
        fillMode='outline'
        dataItemKey='id'
        textField='name'
        value={getMonthsForLanguage(props.selectedLanguageId).find((m) => m.name === props.month)}
        onChange={(e: DropDownListChangeEvent) => {
          props.onMonthChange(e.value.id);
        }}
      />
      <DropDownList
        data={isNotNil(props.month) && isNotNil(props.year) ? getDaysForMonthName(props.month, parseInt(props.year), props.selectedLanguageId) : []}
        label={getWordingForLanguage('day', props.selectedLanguageId)}
        disabled={!props.month || !props.year}
        fillMode='outline'
        value={props.day ?? ''}
        onChange={(e: DropDownListChangeEvent) => {
          props.onDayChange(e.value?.toString());
        }}
      />
      <Button
        themeColor={'primary'}
        style={{ marginTop: '1em', width: '100%' }}
        disabled={!props.canLogin || props.loggingIn}
        onClick={() => props.onLogin()}>
        {props.loggingIn === true ? getWordingForLanguage('loggingIn', props.selectedLanguageId) : getWordingForLanguage('login', props.selectedLanguageId)}
      </Button>
      <Button
        fillMode="outline"
        onClick={() => props.onUseAlternateLogin()}
        style={{
          borderColor: 'rgba(0, 0, 0, 0.38)',
          margin: '1em 0 0.8em 0',
          textTransform: 'none',
          width: '100%',
        }}
      >
        {getWordingForLanguage('loginWithSocial', props.selectedLanguageId)}
      </Button>
    </div>
  );
};

export default NameDoBLogin;
